/**
 * Converts a number to US format for long numbers using comma separators for thousands.
 *
 * @param {number} number The number to convert.
 * @return {String} Returns number separated by comma in thousands or 0 if no number provided
 * @example
 *
 * formatNumberToThousandSeparator(166554);
 * // -> 166,554
 *

 */
export const formatNumberToThousandSeparator = (number) => {

  const num = Number(number) || 0;

  //use the american local which uses comma separator
  return num.toLocaleString('en-US');
};
